import React, { Component } from 'react'


class Payment extends Component {
  
  render() {
    let payment = this.props.payment
        
    let paymentDate = new Intl.DateTimeFormat("de-DE", {
        year: "numeric",
        month: "numeric",
        day: "2-digit", 
        hour:  "2-digit",
        minute: "2-digit",
       second: "2-digit"
     }
    ).format(new Date(payment.whents))

    return (
        <tr>
            <td>{payment.id}</td>
            <td>{payment.user  && payment.user.username  ?
                <div>{payment.user.username}</div> :
                <div></div>
            }</td>
            <td>{
                <div>{paymentDate}</div> 
            }</td>
            <td>{ 
                <div>{payment.service_points}</div> 
            }</td>
            <td>{ 
                <div>{payment.amount}</div> 
            }</td>
            <td>{ 
                <div>{payment.currency}</div> 
            }</td>
            <td>{ 
                <div>{payment.state}</div> 
            }</td>
            <td>{ 
                <div>{payment.description}</div> 
            }</td>
            <td>{ 
                <div>{payment.source_token}</div> 
            }</td>
        </tr>
        )
    } 

}

export default Payment